import { Button, Input, Select } from "antd";
import { SignalContext } from "context/SignalContext";
import Cookies from "js-cookie";
import { StreamingCameraType } from "lib/types";
import { useCommonService } from "pages/service";
import { useContext, useEffect, useRef, useState } from "react";
import usePresetRtcService from "ui/preset/service";
import { UsingCameraPlayer } from "ui/streaming/single-pc-adapter";
import PtzControl from "ui/dealer-focus/ptz-control";
import { STREAM_TYPE_LIVE } from "webrtc-player/common/base";
import { showToast } from "ui/components/common";
import MarkPresetMap from "./markPresetMap";
import { APIProvider } from "@vis.gl/react-google-maps";
let key = 0;
export default function PresetStreaming({
  camera,
  onTagListChange,
  tagList,
  presetName,
  onPresetNameChange,
  presetLocation,
  onPresetLocationChange,
  selectedSite,
}) {
  const { getCredentials } = useCommonService();
  const [mapVisible, setMapVisible] = useState(false);
  const token = Cookies.get("token");
  const { sessionId } = useContext(SignalContext);
  const [streamingCamera, setStreamingCamera] = useState(null);
  const cameraPlayerRef = useRef(null);
  useEffect(() => {
    if (!camera) return;
    getCredentials([camera.nvrId], camera.orgId).then(
      ([objCredentialFound]) => {
        const _streamingCamera: StreamingCameraType = {
          orgId: camera.orgId,
          nvrId: camera.nvrId,
          devId: camera.devId,
          type: camera.type,
          cameraId: camera.id,
          cameraName: camera.name,
          token: token!,
          turn: objCredentialFound?.turn,
          rtcToken: objCredentialFound?.token,
          sessionId: sessionId,
          cameraMac: camera.macAddress,
          remoteIndex: camera.remoteIndex,
          streamId: "0",
          status: camera.status,
          siteId: camera.siteId,
          siteName: camera.siteName,
          capabilities: camera.capabilities,
          videoInfo: {
            width: camera.mainStream?.resolution.width,
            height: camera.mainStream?.resolution.height,
            fps: camera.mainStream?.frameRate,
          },
        };
        key++;
        setStreamingCamera(_streamingCamera);
      },
    );
  }, [camera]);
  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          height: "100%",
          justifyContent: "space-around",
        }}
      >
        <div
          style={{
            borderRadius: "16px",
            overflow: "hidden",
            margin: "0px 4px",
            flex: "none",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div style={{ flex: "none", width: "437px" }}>
            {streamingCamera && (
              <UsingCameraPlayer
                ref={cameraPlayerRef}
                key={key}
                showPtz={false}
                muted={false}
                selected={false}
                streamingCamera={streamingCamera}
                streamType={STREAM_TYPE_LIVE}
                visible={true}
              />
            )}
          </div>
          {streamingCamera?.capabilities?.ptz && (
            <div
              style={{
                flex: "none",
                minWidth: "192px",
                transform: "translateX(-5px)",
                backgroundColor: "#FAFAFA",
              }}
            >
              <PtzControl
                camera={{
                  ...streamingCamera,
                  id: streamingCamera?.cameraId,
                  macAddress: streamingCamera?.cameraMac,
                }}
                width="160px"
                bottomHeight="15%"
                style={{ height: "100%" }}
                hidePresetList={true}
              />
            </div>
          )}
        </div>
        <div
          style={{
            flex: "none",
            width: "277px",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div style={{ flex: "none" }}>
            {streamingCamera?.capabilities?.ptz ? (
              <Input
                placeholder="Input preset name"
                style={{ height: "54px" }}
                value={presetName}
                onChange={onPresetNameChange}
              />
            ) : (
              <div style={{ fontSize: "18px" }}>Static Preset</div>
            )}
          </div>
          <div
            style={{
              flex: "1",
              width: "100%",
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <div style={{ flex: "none", margin: "8px 0px" }}>Tags</div>
            <Select
              mode="tags"
              style={{
                width: "100%",
                overflowY: "auto",
                height: "102px",
              }}
              value={tagList}
              onChange={(e) => onTagListChange(e)}
              open={false}
              suffixIcon={<></>}
            />
          </div>
          <div>
            <Button
              style={{ marginTop: "10px" }}
              onClick={() => setMapVisible(true)}
              className="primaryButton bordered"
            >
              Map
            </Button>
          </div>
        </div>
        <APIProvider
          apiKey={"AIzaSyAqk45RIVytV7tiTjTy2UISpHEgSWjl1vg"}
          onLoad={() => console.log("Maps API has loaded.")}
        >
          <MarkPresetMap
            visible={mapVisible}
            onClose={() => setMapVisible(false)}
            site={selectedSite}
            presetName={presetName}
            presetLocation={presetLocation}
            onPresetLocationChange={onPresetLocationChange}
          />
        </APIProvider>
      </div>
    </>
  );
}
